import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { sessionService } from '../service/session.service';

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    // Listener für Session-Änderungen registrieren
    const handleSessionChange = (session: any) => {
      console.log('[DEBUG] ProtectedRoute: Session-Änderung erkannt, loggedIn:', session.loggedIn);
      setIsAuthenticated(session.loggedIn);
    };

    // Initial den Status aus dem Session-Service holen
    const initialCheck = async () => {
      console.log('[DEBUG] ProtectedRoute: Initiale Authentifizierungsprüfung...');
      // Nutze die bereits validierte Session aus dem Service
      // (diese wurde im index.tsx oder anderer Stelle bereits validiert)
      const currentSession = sessionService.getCurrentSession();
      
      if (currentSession) {
        console.log('[DEBUG] ProtectedRoute: Verwende bereits validierte Session');
        setIsAuthenticated(currentSession.loggedIn);
      } else {
        // Falls keine Session vorhanden, einmalig validieren
        console.log('[DEBUG] ProtectedRoute: Keine existierende Session, validiere...');
        const session = await sessionService.validate();
        setIsAuthenticated(session.loggedIn);
      }
    };
    
    // Event-Listener hinzufügen
    sessionService.addSessionListener(handleSessionChange);
    
    // Initialer Check
    initialCheck();
    
    // Cleanup-Funktion
    return () => {
      sessionService.removeSessionListener(handleSessionChange);
    };
  }, []);

  // Zeige Loading-Zustand, während die Authentifizierung geprüft wird
  if (isAuthenticated === null) {
    return <div>Laden...</div>;
  }

  // Wenn nicht authentifiziert, zur Login-Seite weiterleiten
  if (!isAuthenticated) {
    console.log('[DEBUG] ProtectedRoute: Nicht authentifiziert, Weiterleitung zu /login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Wenn authentifiziert, geschützte Route rendern
  return <>{element}</>;
};

export default ProtectedRoute; 